import React, { useState } from 'react';
import { TextInput, Button } from 'is24-corecss';

export type LocalLoginPageProps = { onLogin: (userName: string) => void };

export const LocalLoginPage = ({ onLogin }: LocalLoginPageProps) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return (
    <div className='padding-xl'>
      <h3 className='margin-bottom-l'>Local login page</h3>

      <div className='grid gutter-s' id='loginForm'>
        <div className='grid-item one-whole'>
          <TextInput.Root id='username' className='desk-one-third'>
            <TextInput.Label>{'Username'}</TextInput.Label>
            <TextInput.Input
              placeholder='Username'
              value={username}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value)}
            />
          </TextInput.Root>
        </div>

        <div className='grid-item one-whole'>
          <TextInput.Root id='password' className='desk-one-third'>
            <TextInput.Label>{'Password'}</TextInput.Label>
            <TextInput.Input
              placeholder='Password'
              type='password'
              value={password}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
            />
          </TextInput.Root>
        </div>

        <div className='grid-item one-whole margin-top-l'>
          <Button id='loginOrRegistration' onClick={() => onLogin(username)} appearance='primary'>
            Login
          </Button>
        </div>

        <div className='grid-item one-whole margin-top-l'>
          <Button className='font-body-small-regular margin-top-xxl' id='submit'>
            Dummy submit for AT
          </Button>
        </div>
      </div>
    </div>
  );
};
